//
//
//
//
//
//
//

export default{
  props: {
    placeholderTxt: {
      type: String,
      default: 'please enter value'
    }
  },
  data() {
    return {
      val: ""
    }
  },
  created() {

  },
  methods: {
    handleSearch() {
      this.$emit('updateSearh', this.val.trim())
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/g-search/index.vue